import React, { useState } from 'react';
import type { ReactNode } from 'react';

interface AccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  icon?: ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({ 
  title, 
  children, 
  defaultOpen = false,
  icon 
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
      <div className="border-b border-gray-200">
        <h2>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center justify-between w-full p-6 font-medium text-left text-gray-900 hover:bg-gray-50 transition-colors"
            type="button"
            aria-expanded={isOpen}
          >
            <span className="text-lg font-semibold flex items-center gap-3">
              {icon && <span className="text-2xl">{icon}</span>}
              {title}
            </span>
            <span 
              className={`material-symbols-outlined text-2xl transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`}
            >
              expand_more
            </span>
          </button>
        </h2>
        <div
          className={`transition-all duration-200 ease-in-out ${
            isOpen ? 'max-h-[5000px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          <div className="p-6 pt-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

